import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import http from './services/http'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 将http服务挂载到Vue原型上
Vue.prototype.$http = http

// 监听页面刷新事件，清除localStorage中的selected_session_id
window.addEventListener('beforeunload', () => {
  localStorage.removeItem('selected_session_id')
  console.log('页面刷新，已清除selected_session_id');
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
